// extracted by mini-css-extract-plugin
export var siteHeader = "Header-module--site-header--1foI4";
export var logo = "Header-module--logo--3k9WL";
export var sparkTitle = "Header-module--spark-title--1i2eL";
export var sparkLogo = "Header-module--spark-logo--2s1Qw";
export var blogTitle = "Header-module--blog-title--1QP-I";
export var ctaNav = "Header-module--cta-nav--3KQ8o";
export var sparkButton = "Header-module--spark-button--3xbDm";
export var menuItem = "Header-module--menu-item--rGRBW";
export var highLevelLink = "Header-module--high-level-link--hs1M8";
export var dark = "Header-module--dark--11aTQ";
export var menuItemLink = "Header-module--menu-item-link--G9OSm";
export var darkFix = "Header-module--dark-fix--1Pil6";
export var darkWrap = "Header-module--dark-wrap--Fm3jf";
export var itemDesc = "Header-module--item-desc--3oErV";
export var button = "Header-module--button--26VdX";
export var svgImg = "Header-module--svgImg--2xVVP";